import React, { useEffect, useState } from 'react';
import {Typography, Button, Spin, Modal, Form, Input, Row, Col, Space, Divider, Avatar } from "antd";
import {UserOutlined, MailOutlined, PlusOutlined, GithubOutlined} from "@ant-design/icons";
import {PageContainer, ProCard} from "@ant-design/pro-components";
import { useNavigate } from "react-router-dom";
import { fetchProfile } from "../../components/Profile";
import {deleteContact, fetchContacts, saveContent} from "../../components/Contacts";

const { Text, Title } = Typography;

const ContactsManagement = () => {
    const navigate = useNavigate();
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentContact, setCurrentContact] = useState(null);
    const [form] = Form.useForm();
    const token = localStorage.getItem("token");
    document.title = "Контакты";
    useEffect(() => {
        async function loadProfile() {
            try {
                await fetchProfile(token);
            } catch (error) {
                localStorage.removeItem("token");
                navigate("/login");
            }
        }
        if (token) {
            loadProfile();
        }
        fetchUserContacts();
    }, []);

    const fetchUserContacts = async () => {
        try {
            const data = await fetchContacts(token);
            setContacts(data);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            saveContent(values, currentContact, token);
            fetchUserContacts();
            setIsModalOpen(false);
            form.resetFields();
        } catch (error) {
            console.error(error);
        }
    };

    const handleDelete = async (id) => {
        try {
            deleteContact(id, token);
            fetchUserContacts();
        } catch (error) {
            console.error("Ошибка удаления контакта:", error);
        }
    };

    if (loading) return <Spin size="large" style={{ display: "block", margin: "50px auto" }} />;

    return (
        <PageContainer title="Контакты разработчиков" content="Здесь представлены контакты разработчиков">
            <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setCurrentContact(null);
                    form.resetFields();
                    setIsModalOpen(true);
                }}
                style={{ marginBottom: 16 }}
            >
                Добавить контакт
            </Button>
            <Row gutter={[16, 16]} justify="center" align="stretch">
                {contacts.map((contact) => (
                    <Col key={contact.id} xs={24} sm={12} md={8}>
                        <div style={{ height: "100%" }}>
                            <ProCard
                                hoverable
                                bordered
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    textAlign: "center",
                                }}
                                bodyStyle={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flexGrow: 1,
                                    height: "100%",
                                }}
                            >
                                <div style={{ flexGrow: 1 }}>
                                    <Space direction="vertical" align="center" size="middle">
                                        <Avatar size={80} src={contact.avatar} icon={<UserOutlined />} alt={contact.name} />
                                        <Title level={4} style={{ margin: 0 }}>{contact.name}</Title>
                                        <Text type="secondary">{contact.role}</Text>
                                        <Divider style={{ margin: "12px 0" }} />
                                        <Text>
                                            <MailOutlined style={{ marginRight: 4, color: "#1890ff" }} />
                                            <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                        </Text>
                                        {contact.telegram && (
                                            <Text>
                                                <a
                                                    href={contact.telegram}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Telegram
                                                </a>
                                            </Text>
                                        )}
                                        {contact.github && (
                                            <Text>
                                                <GithubOutlined
                                                    style={{ marginRight: 4, color: "#1890ff" }}
                                                />
                                                <a
                                                    href={contact.github}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    GitHub
                                                </a>
                                            </Text>
                                        )}
                                        <Button onClick={() => { form.setFieldsValue(contact); setCurrentContact(contact); setIsModalOpen(true); }}>Редактировать</Button>
                                        <Button danger onClick={() => handleDelete(contact.id)}>Удалить</Button>
                                    </Space>
                                </div>
                            </ProCard>
                        </div>
                    </Col>
                ))}
            </Row>
            <Modal
                title={currentContact ? "Редактировать контакт" : "Добавить контакт"}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                onOk={handleSave}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Имя"
                        rules={[{ required: true, message: "Введите имя" }]}
                    >
                        <Input placeholder="Введите имя" />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, type: "email", message: "Введите корректный email" }]}
                    >
                        <Input placeholder="Введите email" />
                    </Form.Item>

                    <Form.Item
                        name="role"
                        label="Роль"
                        rules={[{ required: true, message: "Введите роль" }]}
                    >
                        <Input placeholder="Введите роль (например, Разработчик)" />
                    </Form.Item>

                    <Form.Item
                        name="telegram"
                        label="Telegram"
                    >
                        <Input placeholder="Введите ссылку на Telegram (https://t.me/username)" />
                    </Form.Item>

                    <Form.Item
                        name="github"
                        label="GitHub"
                    >
                        <Input placeholder="Введите ссылку на GitHub (https://github.com/username)" />
                    </Form.Item>

                    <Form.Item
                        name="avatar"
                        label="Аватар (URL)"
                    >
                        <Input placeholder="Введите ссылку на изображение (URL)" />
                    </Form.Item>
                </Form>
            </Modal>
        </PageContainer>
    );
};

export default ContactsManagement;